"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./OnboardingCard.css");

var _react = _interopRequireDefault(require("react"));

var _ContentItem = _interopRequireDefault(require("../../../shared/components/cms/ContentItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "onboarding-card"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "onboarding-header"
  }, "Our ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "solutions are simple"), " to implement."), /*#__PURE__*/_react.default.createElement("img", {
    src: require("../../assets/redesign2020/products/onboarding.svg"),
    alt: "Onboard Gradifi with ease",
    className: "onboarding-image"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "onboarding-body"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "onboarding-body-header"
  }, "Get employees ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "onboarded with ease"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    tag: "p",
    sharedKey: "marketing2020/onboarding",
    className: "onboarding-body-text",
    contentKey: "onboardingBodyText"
  })));
};

exports.default = _default;